import { StcsFpnaTypeEnum } from '~/protos/gen/stcs_enums.entity'
import { StcsFstmtEnum } from '~/protos/gen/stcs_enums.entity'
import type { FormulaOperand } from '~/types/formula-based'
import { useNuxtApp } from '#imports'

export function useRowUtils() {
  const $tolgee = useNuxtApp().$tolgee

  function getRowTypeClass(row: PlanningRowData): FormulaOperand['display_type'] {
    switch (row.fpna_type) {
      case StcsFpnaTypeEnum.SFT_TOTAL_CML:
      case StcsFpnaTypeEnum.SFT_TOTAL_NCML:
        return 'total'
      case StcsFpnaTypeEnum.SFT_SUB_TOTAL:
        return 'subtotal'
      case StcsFpnaTypeEnum.SFT_LEVEL_1:
        return 'level-1'
      case StcsFpnaTypeEnum.SFT_LEVEL_2: {
        if (row.rowClass === 'sub-custom-row') {
          return 'subposition'
        }
        if (row.rowClass === 'custom-row' || row.is_position_row) {
          return 'planning'
        }
        return 'level-2'
      }
      case StcsFpnaTypeEnum.SFT_LEVEL_3:
        return 'level-3'
      case StcsFpnaTypeEnum.SFT_ACC_ITEM:
        return 'subposition'
      default:
        return 'default'
    }
  }

  function getRowFpnaType(fpna_type: StcsFpnaTypeEnum): FormulaOperand['display_type'] {
    switch (fpna_type) {
      case StcsFpnaTypeEnum.SFT_LEVEL_1:
        return 'level-1'
      case StcsFpnaTypeEnum.SFT_LEVEL_2:
        return 'level-2'
      case StcsFpnaTypeEnum.SFT_LEVEL_3:
        return 'level-3'
      case StcsFpnaTypeEnum.SFT_SUB_TOTAL:
      case StcsFpnaTypeEnum.SFT_TOTAL_CML:
      case StcsFpnaTypeEnum.SFT_TOTAL_NCML:
        return 'total'
      default:
        return 'level-2'
    }
  }

  function getRowTypeLabel(row: PlanningRowData): string {
    switch (row.fpna_type) {
      case StcsFpnaTypeEnum.SFT_TOTAL_CML:
      case StcsFpnaTypeEnum.SFT_TOTAL_NCML:
        return 'Total'
      case StcsFpnaTypeEnum.SFT_SUB_TOTAL:
        return 'Subtotal'
      case StcsFpnaTypeEnum.SFT_LEVEL_1:
        return 'Level 1'
      case StcsFpnaTypeEnum.SFT_LEVEL_2:
        return 'Level 2'
      case StcsFpnaTypeEnum.SFT_LEVEL_3:
        return 'Level 3'
      case StcsFpnaTypeEnum.SFT_ACC_ITEM:
        return 'Subposition'
      default:
        return `Level ${row.path_level?.length || 1}`
    }
  }

  function getStatementLabel(row: PlanningRowData): string {
    switch (row.fstmt_type) {
      case StcsFstmtEnum.SFSE_PNL:
        return $tolgee.t('general-terms-pnl')
      case StcsFstmtEnum.SFSE_BS:
        return $tolgee.t('general-terms-bs')
      case StcsFstmtEnum.SFSE_CF:
        return $tolgee.t('general-terms-cf')
      default:
        return 'Unknown'
    }
  }

  return { getRowTypeClass, getRowTypeLabel, getStatementLabel, getRowFpnaType }
}
